import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { JSONMap as t } from "../../core/jsonMap.js";
import { JSONSupport as r } from "../../core/JSONSupport.js";
import { property as o } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { cast as s } from "../../core/accessorSupport/decorators/cast.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";

var _n;

var l = new t({
  percentTotal: "percent-of-total",
  ratio: "ratio",
  percent: "percent"
}),
    p = new t({
  sizeInfo: "size",
  colorInfo: "color",
  transparencyInfo: "opacity",
  rotationInfo: "rotation"
}),
    a = {
  key: function key(e) {
    return "number" == typeof e ? "number" : "string";
  },
  typeMap: {
    number: Number,
    string: String
  },
  base: null
},
    u = ["high-to-low", "above-and-below", "centered-on", "extremes"],
    m = _toConsumableArray(new Set(["high-to-low", "above-and-below", "centered-on", "extremes", "90-10", "above", "below"].concat(["high-to-low", "above-and-below", "90-10", "above", "below"]))),
    y = ["seconds", "minutes", "hours", "days", "months", "years"];

var d = _n = /*#__PURE__*/function (_r) {
  _inherits(n, _r);

  var _super = _createSuper(n);

  function n(e) {
    var _this;

    _classCallCheck(this, n);

    _this = _super.call(this, e), _this.endTime = null, _this.field = null, _this.maxSliderValue = null, _this.minSliderValue = null, _this.startTime = null, _this.type = null, _this.units = null;
    return _this;
  }

  _createClass(n, [{
    key: "castEndTime",
    value: function castEndTime(e) {
      return "string" == typeof e || "number" == typeof e ? e : null;
    }
  }, {
    key: "castStartTime",
    value: function castStartTime(e) {
      return "string" == typeof e || "number" == typeof e ? e : null;
    }
  }, {
    key: "style",
    get: function get() {
      return "color" === this.type ? this._get("style") : null;
    },
    set: function set(e) {
      this._set("style", e);
    }
  }, {
    key: "theme",
    get: function get() {
      return "color" === this.type || "size" === this.type ? this._get("theme") || "high-to-low" : null;
    },
    set: function set(e) {
      this._set("theme", e);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _n({
        endTime: this.endTime,
        field: this.field,
        maxSliderValue: this.maxSliderValue,
        minSliderValue: this.minSliderValue,
        startTime: this.startTime,
        style: this.style,
        theme: this.theme,
        type: this.type,
        units: this.units
      });
    }
  }]);

  return n;
}(r);

e([o({
  types: a,
  json: {
    write: !0
  }
})], d.prototype, "endTime", void 0), e([s("endTime")], d.prototype, "castEndTime", null), e([o({
  type: String,
  json: {
    write: !0
  }
})], d.prototype, "field", void 0), e([o({
  type: Number,
  json: {
    write: !0
  }
})], d.prototype, "maxSliderValue", void 0), e([o({
  type: Number,
  json: {
    write: !0
  }
})], d.prototype, "minSliderValue", void 0), e([o({
  types: a,
  json: {
    write: !0
  }
})], d.prototype, "startTime", void 0), e([s("startTime")], d.prototype, "castStartTime", null), e([o({
  type: l.apiValues,
  value: null,
  json: {
    type: l.jsonValues,
    read: l.read,
    write: l.write
  }
})], d.prototype, "style", null), e([o({
  type: m,
  value: null,
  json: {
    type: m,
    origins: {
      "web-scene": {
        type: u,
        write: {
          writer: function writer(e, t) {
            u.indexOf(e) > -1 && (t.theme = e);
          }
        }
      }
    },
    write: !0
  }
})], d.prototype, "theme", null), e([o({
  type: p.apiValues,
  json: {
    type: p.jsonValues,
    read: p.read,
    write: p.write
  }
})], d.prototype, "type", void 0), e([o({
  type: y,
  json: {
    type: y,
    write: !0
  }
})], d.prototype, "units", void 0), d = _n = e([i("esri.renderers.support.AuthoringInfoVisualVariable")], d);
var h = d;
export { h as default };